export default __webpack_public_path__ + "f92f856e711b48052e8be80544b23f2d.svg";